const testActionsMixin = {
    data() {
        return {
            comment: '',
            eventInterval: 10,
            offices: [],
        }
    },
    methods: {
        fetchEventFormOptions() {
            return this.axios.get( this.$config.urls.event.fetchFormOptions.url ).then( response => {
                this.eventInterval = response.data.data.eventInterval;
                this.offices = response.data.data.offices;
                return this.objectToArray( response.data.data.filters );
            } ).catch(()=>{});
        },
        rejectEvent( eventId, comment ) {
            return this.axios.post( this.$config.urls.event.rejectEvent.url.replace( ':id', eventId ), comment );
        },
    }
};

export default testActionsMixin;
